<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CRow alignHorizontal="center" alignVertical="center">
        <CCol col="1">
          <CRow alignHorizontal="end">
            <div
              class="containerIconLeft"
              @click="funcRouteBack(content.navigate.previous.action)"
            >
              <font-awesome-icon
                class="IconLeft"
                icon="chevron-left"
                size="1.5"
              ></font-awesome-icon>
            </div>
          </CRow>
        </CCol>
        <CCol col="10">
          <CardMatrix
            :cardContent="content"
            :checkWidth="widthScreen.toString()"
            :typeInfo="typeInfo"
            :info="info"
            :cardSetting="cardSetting"
            :MatrixTones="MatrixTones"
            @setIsRightActive="setIsRightActive"
            @setInfo="setInfo"
            @setAnwser="setAnwser"
            :initialAnswer="data"
            :AnswerChoice="answer"
          />
        </CCol>
        <CCol col="1">
          <CRow>
            <div
              :class="getNextButtonColor(isRightActive)"
              @click="getNextButtonAttribute(isRightActive)"
              class="containerIconRight"
            >
              <font-awesome-icon
                class="IconRight"
                icon="chevron-right"
                size="1.5"
              ></font-awesome-icon>
            </div>
          </CRow>
        </CCol>
      </CRow>
    </template>
  </div>
</template>

<script>
import CardMatrix from "../../components/template/Chinese1/CardMatrix";
import "../../assets/scss/_chineseStyle.scss";
import "../../assets/scss/_chineseIcon.scss";
import { mapGetters } from "vuex";
import TEMPLATE from "../../TEMPLATE.vue";
import LoadingMDL from "../../components/loading/LoadingMDL";

export default {
  components: { CardMatrix, TEMPLATE, LoadingMDL },
  name: "IAM01",
  data() {
    return {
      initialCount: 0,
      isRightActive: false,
      isStepTwo: false,
      nextButton: Function,
      MatrixTones: "VALUE",
      content: {},
      cardSetting: {
        infoType: "text",
        choiceType: "audio",
        answerType: "one",
      },
      info: "Initials",
      typeInfo: "Initials",
      widthScreen: window.innerWidth,
      lang: this.$store.getters["language/getLanguage"],
      baseUrl: process.env.VUE_APP_URL_SOUND,
      courseCode: "",
      checkAnswer: [],
      count: 6,
      CheckWidth: window.innerWidth.toString(),
      loaded: false,
      userTemplateData: [],
      nextAction: [],
      pageCode: "",
      data: [],
      answer: [],
      InputAns: "",
      courseSection: "",
      startTime: "",
      condition: [],
      courseId: "",
      loading: false,
    };
  },

  computed: {
    ...mapGetters({
      allCourse: "template/getTemplateContent",
      getUserTemplate: "template/getUserTemplate",
      loadingGetter: "template/loadingGetter",
    }),
  },

  watch: {
    allCourse: function(val) {
      if (!val.enable) {
        alert("Access denied!");
        this.$router.push({ name: val.navigate.close.action });
      } else {
        this.content = val;
        this.courseSection = this.$store.getters['necessary/getUserCourseSection']
        this.$store.dispatch("template/createUserTemplateData", {
          code: this.courseId,
          template: val._id,
          section: this.courseSection,
        });
        this.checkTemplate(val);
        this.checkCount(val);
        this.data = Array(val.content.question[0].item.length);
        this.answer = Array(
          val.content.question[0].choices[0].choice.choices.item.comment.length
        );
      }
    },
    checkAnswer(value) {},
    initialCount(value) {
      if (this.count <= value) this.setIsRightActive(true);
    },
    info(value) {
      if (value == "Initials") {
        this.setIsRightActive(false);
        this.initialCount = this.initialCount + 1;
      }
    },
    getUserTemplate: function(val) {
      this.userTemplateData = val;
      this.condition = [
        {
          criteria: val.data.condition.criteriaType[0].criteria._id,
          val: val.data.condition.criteriaType[0].val,
        },
      ];
    },
    loadingGetter: function(val) {
      if (val == true) {
        if (
          this.pageCode === "IAM01-6" ||
          this.pageCode === "IAM01-7" ||
          this.pageCode === "IAM01-8"
        ) {
          var CorrectAns = this.content.content.question[0].choices[0].choice
            .choices.item.comment;
          if (this.InputAns === CorrectAns) {
            this.$store.commit("template/checkingTrueFalse", true);
          } else {
            this.$store.commit("template/checkingTrueFalse", false);
          }
        }
        this.$router.push(this.nextAction);
      }
    },
    data: function(val) {
      for (let i = 0; i < val.length; i++) {
        if (i === 0) {
          this.InputAns = val[i];
        } else if (i > 0) {
          if (val[i] != undefined) {
            this.InputAns = this.InputAns + val[i];
          }
        }
      }
    },
  },

  mounted() {
    let body = {};
    body.code = this.courseId;
    body.templateCode = `IAM01-` + this.$route.params.id;
    this.$store.dispatch("template/fetchContent", body);
  },

  created() {
    this.courseCode = this.$store.getters["necessary/getLerningCourse"].code;
    this.courseId = this.$store.getters["necessary/getLerningCourse"]._id;
    this.pageCode = `IAM01-` + this.$route.params.id;
    this.lang = this.$store.state.language.language;
    this.startTime = this.$helpers.getDateFormat();
  },

  beforeDestroy() {},
  methods: {
    checkWidth() {
      if (this.CheckWidth > 800) {
        return "container-chinese-card";
      } else if (this.CheckWidth <= 800) {
        return "container-chinese-card-mobile";
      }
    },
    checkCount(val) {
      var tempId = val.codeTemplate;
      if (tempId === "IAM01-1") {
        this.count = 5;
      } else if (tempId === "IAM01-4") {
        this.count = 4;
      }
    },
    checkLangClass() {
      if (this.lang == "CN") {
        return "fontChinese";
      } else if (this.lang == "PIN IN") {
        return "fontPinin";
      } else {
        return "";
      }
    },
    funcRouteBack(tempId) {
      let str = tempId.split("-");
      let checkUrl = str[0];
      if (checkUrl === "IAM01") {
        this.$store.dispatch("template/fetchContent", tempId);
        this.$router.push("/" + str[0] + "/" + str[1]);
      } else {
        this.$router.push("/" + str[0] + "/" + str[1]);
      }
    },
    funcRoute(tempId) {
      const useTime = this.$helpers.getUseTime();
      let val = tempId.split("-");
      this.nextAction = "/" + val[0] + "/" + val[1];
      this.$store.dispatch("template/saveUserTemplateData", {
        code: this.courseId,
        template: this.content._id,
        section: this.courseSection,
        startTime: this.startTime,
        endTime: this.$helpers.getDateFormat(),
        condition: this.condition,
      });
    },
    setIsRightActive(status) {
      this.isRightActive = status;
    },
    getNextButtonColor(status) {
      if (status) return "containerIconRight-matrix active";
      else return "containerIconRight-matrix";
    },
    setAnwser(value) {
      var CorrectAnsLength = this.content.content.question[0].choices[0].choice
        .choices.item.comment.length;

      if (value.length >= CorrectAnsLength) {
        value = [];
        this.checkAnswer === [];
      } else {
        this.checkAnswer = value;
        this.InputAns = this.checkAnswer[0] + this.checkAnswer[1];
      }
    },
    setInfo(value) {
      this.info = value;
    },
    setNextButtonAttribute(func) {
      this.nextButton = func;
    },
    getNextButtonAttribute(status) {
      var tone = this.content.content.question[0].title[1].value;
      if (status && this.count <= this.initialCount) {
        let path = this.content.navigate.next.action;
        this.funcRoute(path);
      } else if ((this.isRightActive = true && this.MatrixTones == "Tones")) {
        let path = this.content.navigate.next.action;
        this.funcRoute(path);
      } else if ((this.isRightActive = true && tone == "Audio")) {
        let path = this.content.navigate.next.action;
        this.funcRoute(path);
      } else if (status && this.count > this.initialCount) {
        this.setInfo("Initials");
      } else {
        alert("Please complete the assignment");
      }
    },
    checkTemplate() {
      var data = this.content.content.question[0].multiSelect;
      var tone = this.content.content.question[0].title[1].value;
      if (data == false && tone == "Tone") {
        this.setIsRightActive(true);
        this.cardSetting = {
          infoType: "text",
          choiceType: "audio",
          answerType: "one",
        };
        this.MatrixTones = "Tones";
        this.info = "Tones";
      } else if (data == true && tone == "Audio") {
        this.setIsRightActive(true);
        this.cardSetting = {
          infoType: "text",
          choiceType: "audio",
          answerType: "multi",
        };
        this.MatrixTones = "";
        this.typeInfo = "audio";
        this.info = "";
      } else {
        this.cardSetting = {
          infoType: "text",
          choiceType: "audio",
          answerType: "one",
        };
      }
    },
  },
};
</script>
<style></style>
